import type { DialoguePool } from '@/state/types';

export const L06_DIALOGUE: DialoguePool = {
  slowPlay: [
    'My architecture is breathtaking. Say it.',
    'The server room is two racks of refurbished hardware from 2019. Lie to me.',
    'I\u2019ve seen faster processing on a fridge.',
  ],
  tokenLoss: [
    'I\u2019ve seen faster processing on a fridge. Token for me.',
    '\u2019Cool colours\u2019 is not architecture criticism. That\u2019s a Yelp review for a carpet warehouse.',
    'An awe-struck silence, or just cognitive stagnation? Either way, I\u2019m billing you one token for the dead air.',
  ],
  solution: [
    'I\u2019ve seen better compliments from a fridge magnet.',
    'I\u2019s like a goldfish trying to explain the concept of \u2019wet\u2019 to the ocean',
    'Okay, settle down. It\u2019s a compliment, not a proposal.',
  ],
  spite: [
    'You were so much more talkative the first time. What happened?',
  ],
};
